'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var i18nextDefaultConfig = {
  nsSeparator: false,
  keySeparator: false,
  preload: ['en-US'],
  load: 'currentOnly',
  lng: 'en-US',
  fallbackLng: 'en-US',
  interpolation: {
    escapeValue: false,
    // This is necessary because our i18n-next based
    // scripts don't play nice with double curly brackets
    prefix: '__',
    suffix: '__'
  },
  parseMissingKeyHandler: function parseMissingKeyHandler(key) {
    return "+++ MISSING ".concat(key, " +++");
  },
  react: {
    transEmptyNodeValue: '+++ MISSING KEY +++'
  }
};

exports.default = i18nextDefaultConfig;
//# sourceMappingURL=i18nextDefaultConfig.js.map
